import { Routes } from '@angular/router';

import { adminControlerGuard } from './core/admin-controler.guard';
import { authGuard } from './core/auth.guard';
import { changePasswordGuard } from './core/change-password.guard';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.component').then((module) => module.LoginComponent)
  },
  {
    path: 'sso-access',
    loadComponent: () =>
      import('./features/sso-access/sso-access.component').then(
        (module) => module.SsoAccessComponent
      )
  },
  {
    path: 'portal',
    loadComponent: () =>
      import('./features/app-shell/app-shell.component').then((module) => module.AppShellComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home'
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./features/home/home.component').then((module) => module.HomeComponent)
      },
      {
        path: 'policies',
        loadComponent: () =>
          import('./features/policies/policies.component').then((module) => module.PoliciesComponent)
      },
      {
        path: 'health-card',
        loadComponent: () =>
          import('./features/health-card/health-card.component').then(
            (module) => module.HealthCardComponent
          )
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('./features/change-password/change-password.component').then(
            (module) => module.ChangePasswordComponent
          ),
        canActivate: [changePasswordGuard]
      },
      {
        path: 'admin-controler',
        loadComponent: () =>
          import('./features/admin-controler/admin-controler.component').then(
            (module) => module.AdminControlerComponent
          ),
        canActivate: [adminControlerGuard]
      }
    ]
  },
  {
    path: 'policy-preview/:id',
    loadComponent: () =>
      import('./features/policy-preview/policy-preview.component').then(
        (module) => module.PolicyPreviewComponent
      ),
    canActivate: [authGuard]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
